import { useQueryParamsHook } from '@/hooks/useQueryParamsHook';
import { useUserPageContextValueHook } from '@/contexts/UserPageContextProvider';
import { useSubscriptionQuery } from '@/hooks/ReactQuery/SubscriptionReactQuery/SubscriptionReactQuery';

export const PRO_PRICE = 4900;
export const REFUND_DAYS = 7;

/**
 * 지금 페이지에서 Pro 기능을 쓸 수 있는지 (서버가 갱신하는 user_pages.planExpiresAt).
 * 결제 스위치가 이 계정에 적용되지 않으면(billing.proLocked=false, 예: OFF) 잠그지 않는다 — 서버 BillingSettingsService.isProPage 와 같은 규칙
 */
export function usePagePro() {
    const userPage = useUserPageContextValueHook()?.userPage;
    const billing = useSubscriptionQuery({ userPageId: userPage?.id }).data?.billing;
    return billing?.proLocked !== true || Number(userPage?.planExpiresAt) > Date.now();
}

export function ProBadge({ className = '' }) {
    return <span className={`rounded-md bg-gradient-to-r from-[#e8798a] to-[#b67ee6] px-1.5 py-0.5 text-[10px] font-extrabold tracking-wide text-white ${className}`}>PRO</span>;
}

/** 요금제 탭으로 이동 */
export function useGoPlanTab() {
    const queryParamsHook = useQueryParamsHook();
    return () => queryParamsHook.setSearchParams({ ...queryParamsHook?.params, tabType: 'PLAN' }, { replace: true });
}

/** 잠긴 기능 자리에 보여 주는 안내 */
export function ProUpsell({ title, description }) {
    const goPlan = useGoPlanTab();
    return (
        <div className="flex flex-col items-start gap-2 rounded-xl bg-gradient-to-br from-[#fdf2f4] to-[#f5effd] p-4 sm:flex-row sm:items-center sm:justify-between">
            <div>
                <p className="flex items-center gap-1.5 text-sm font-bold text-gray-900"><ProBadge /> {title}</p>
                <p className="mt-0.5 text-xs text-gray-600 break-keep">{description}</p>
            </div>
            <button type="button" onClick={goPlan} className="shrink-0 rounded-lg bg-gray-900 px-3 py-2 text-xs font-bold text-white hover:bg-gray-700">
                Pro 알아보기
            </button>
        </div>
    );
}
